import { Toaster } from 'react-hot-toast';

export default function Utils() {
	return <Toaster position="bottom-right" />;
}
